import React from "react";
import { Grid } from "semantic-ui-react";
import { StageSpinner, GooSpinner, MetroSpinner } from "react-spinners-kit";

const CustomLoader: React.FC = () => {

    var names = ["StageSpinner", "GooSpinner", "MetroSpinner"];
    var setName = names[Math.floor(Math.random() * names.length)];

    return (
        <Grid textAlign="center">
            <Grid.Row />
            <Grid.Row>
                <h4>Carregando informações</h4>
            </Grid.Row>
            <Grid.Row>
                <small>Por favor, aguarde!</small>
            </Grid.Row>
            <Grid.Row>
                {
                    setName === "StageSpinner" ?
                        <StageSpinner size={60} color="#ff0066" loading /> : setName === "GooSpinner" ?
                            <GooSpinner size={60} color="#ff0066" loading /> : <MetroSpinner size={60} color="#ff0066" loading />
                }
            </Grid.Row>
        </Grid>
    );
};

export default CustomLoader;
